import React from "react"; 
import { NavLink } from "react-router-dom";

export class CasinoMaratonResults extends React.Component {
    constructor(props) {
        super(props);

        this.state={
            resultsNumber:25, 
            playerNickname:null, 
            playerName:null,
            showPlayerDetails:false,
            playerDetails:[],
            finalResultsNumber:25, 
        };
    }

    dateWithoutTime(date) {
        date.setHours(0, 0, 0, 0);
        return date;
    }

    componentDidMount() {
        if (this.props.player) this.setState({playerNickname:this.props.player.nickname}); 

    }

    showPlayerDetails(playerId) {
        this.setState({
            showPlayerDetails:true, 
            playerName : this.props.results.find(it => it.igracID == playerId).igracIme
        });

        casino.repos.casinoBonusMaratonRepo.rezultatiIgrac(playerId).then((res) => {
            this.setState(
            {
                playerDetails: res,
            })
        });
    }

    isJokerUsed(info) {
        return new Date(info.datumDan).getTime() != this.dateWithoutTime(new Date()).getTime() && info.igraSifra == null;
    }

    isMaratonStarted() {
        return new Date().getTime() > new Date(this.props.info.aktivnoOd).getTime();
    }

    renderPlayerDetails() {
        return(
            <div className={"modal-dialog-overlay" + (this.state.showPlayerDetails ? ' active' : '')}>
                <div className="modal-dialog--inner flex-column">

                <div className="modal-dialog-header clearfix">
                        <div className="modal-dialog--name">
                            <span className="naziv">Rezultati - {this.state.playerName}</span>
                        </div>
                        <a className="active pull-right as-link link link-1" onClick={(e) => {e.preventDefault(); this.setState({ showPlayerDetails: false })}}>
                            <span className="close-icon icon ico-close-thin"></span>
                        </a>
                    </div>

                    <div className="modal-dialog-container flex-1">
                        <div className="modal-dialog-container--inner flex-equal-size">
                            <div>
                                <div className="relative">
                                    <div>
                                        <table className="table-1 v2">
                                        <thead>
                                            <tr>
                                                <th className="text-left text text-6">Naziv Igre</th>
                                                <th className="text-center text text-6">Datum i vrijeme</th>
                                                <th className="text-right text text-6">Max bodovi</th>   
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.playerDetails.map((info, index)=>this.renderPlayerDetailsRow(info, index))}
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderPlayerDetailsRow(info, index) {
        let playIconCss = null;
        let game = info.igraSifra != null ? this.props.games.find(it => it.s == info.sifraMobile ) : null;
        if (game) {
            playIconCss = game.p && (game.p.indexOf("o") != -1) ? 'icon-play-disabled' : 'icon-play';
        }
        return (
            <tr className="horizontal-lines" key={index}>
                {!this.isJokerUsed(info) && 
                <td className="game-name">
                        {game && game.s && <NavLink to={{ pathname: '/promotions/casino-maraton/game/' + this.props.brands[game.bID].nameNormalizirano+ '/' +  casino.utils.normalizeString(game.n)}}><span className={playIconCss}></span></NavLink>}
                    {game && <span>{game.n}</span>}   
                </td>
                }
                {this.isJokerUsed(info) && <td className="game-name"> <span className="joker-image"></span><span style={{color:'#aa0d19'}}>Joker iskorišten</span></td>}
                <td className="game-date text-center text text-6">{casino.utils.dateToShortDateString(new Date(info.datumDan))}. {info.igraSifra != null && casino.utils.dateToTimeString(new Date(info.datum))}</td>
                <td className="text-right">{info.points}</td>
            </tr>
        )
    }

    renderResults() {
        return (
            <span>
                <table className="order-table">
                    <thead>
                        <tr>
                            <th>Plasman</th>
                            <th>Natjecatelj</th>
                            <th>Bodovi danas</th>
                            <th>Bodovi ukupno</th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.props.results.slice(0, this.state.resultsNumber).map((player, index) => this.renderPlayerRow(player, index))}
                    </tbody>
                </table>
                {this.state.resultsNumber < 100 && this.props.results.length > 25 && <div className="text-center">
                    <button className="btn medium fill gray blue margin-top-small no-text-transform" onClick={() => this.setState({resultsNumber: this.state.resultsNumber+25})}>
                        <span className="icon ico-chevron-down"></span> 
                        &nbsp; <span>Prikaži više</span>
                        </button>
                </div>}    
            </span>
        )
    }

    renderPlayerRow(player, index) {
        return (
            <tr key={index} className={this.state.playerNickname == player.nickname ? 'selected' :''} onClick={() => this.showPlayerDetails(player.igracID)}>
                <td>{player.ordinalNumber}. 
                    {this.state.playerNickname == player.nickname && <span className="mark"></span>}
                    <span className={player.ordinalNumber > 9 ? 'img-list double' : 'img-list'}></span></td>
                <td>{player.igracIme}</td>
                <td>{player.pointsToday}</td>
                <td>{player.points}</td>
            </tr>
        )
    }

    renderFinalResults() {
        return (
            <span>
                <table className="order-table">
                    <thead>
                        <tr>
                            <th>Plasman</th>
                            <th>Natjecatelj</th>
                            <th className="award">Nagrada</th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.props.finalResults.slice(0, this.state.finalResultsNumber).map((player, index) => this.renderPlayerRowFinal(player, index))}
                    </tbody>
                </table>
                {this.state.finalResultsNumber < 100 && this.props.finalResults.length > 25 && <div className="text-center">
                    <button className="btn medium fill gray blue margin-top-small no-text-transform" onClick={() => this.setState({finalResultsNumber: this.state.finalResultsNumber+25})}>
                        <span className="icon ico-chevron-down"></span> 
                        &nbsp; <span>Prikaži više</span>
                        </button>
                </div>}    
            </span>
        )
    }

    renderPlayerRowFinal(player, index) {
        return (
            <tr key={index}>
                <td>{(index+1)}. 
                    <span className={player.ordinalNumber > 9 ? 'img-list double' : 'img-list'}></span></td>
                <td>{player.igracIme}</td>
                <td className="award">{casino.utils.numberWithCurrencyFromated(player.nagrada2, this.props.info.valuta)}</td>
            </tr>
        )
    }

    render() {
        return (
            <div className="casino-maraton-section">
                <h2 className="order">
                    {!this.props.info?.uplaceno && this.isMaratonStarted() && 'SuperSkok poredak'}
                {this.props.info?.uplaceno && 'Pobjednici maratona'}
                </h2>    
                {!this.props.info?.uplaceno && this.isMaratonStarted() && <p className="total-players"><span className="red">{this.props.activePlayers} igrača</span> trenutno sudjeluje u Casino Superskoku.</p>}
                {this.props.info?.uplaceno && <p className="total-players"><span className="red">{this.props.activePlayers} igrača</span> je završilo Casino SuperSkok.</p>}
                <div className="divider order"></div>
                {!this.props.info?.uplaceno && this.isMaratonStarted() && this.renderResults()}
                {this.props.info?.uplaceno && this.renderFinalResults()}
                {!this.props.info?.uplaceno && this.renderPlayerDetails()}
            </div>
        )
    }

}